import { RouteConfig } from "vue-router";

export const REmployerServicesExtensionBrowse: RouteConfig = {
  path: "",
  name: "EmployerServicesExtensionBrowse",
  component: () =>
    import(
      /* webpackChunkName: "employer-services-extension-browse" */
      "./VEmployerServicesExtensionBrowse.vue"
    ),
  meta: {
    title: "Select an employee to begin their Skilled Worker Visa extension application",
    backLink: "/",
    version: 2,
  },
};
